'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'pen-nib';
var width = 576;
var height = 512;
var aliases = [10001];
var unicode = 'f5ad';
var svgPathData = 'M442.3 207l95-95-105.4-105.4-95 95 105.4 105.4zm-9.8 12.8l-108.4-108.4-183.3 61.1-90.7 294.9 7.5 7.5 137.5-137.5c-7-9.3-11.1-21-11.1-33.5 0-30.9 25.1-56 56-56s56 25.1 56 56-25.1 56-56 56c-12.6 0-24.2-4.1-33.5-11.1l-137.5 137.5 7.5 7.5 294.9-90.7 61.1-183.3zM384 416L72 512 32 472 128 160 320 96 420.7-4.7 432-16 443.3-4.7 548.7 100.7 560 112 548.7 123.3 448 224 384 416zM200 304a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPenNib = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;